import { useAbValues, useMemo, useMedia } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import constants from 'common/helpers/constants'


type Result = {
  isFirstTimeResubscribeFlow: boolean
  isSecondTimeResubscribeFlow: boolean
}

const useResubscribeFlows = () => {
  const { isMobile } = useMedia()

  const { firstSubscriptionDate, subscriptionDate, isSubscriptionCancelled } = useConnect({
    firstSubscriptionDate: 'models.me.firstSubscriptionDate',
    subscriptionDate: 'models.subscription.subscriptionDate',
    isSubscriptionCancelled: 'models.subscription.isCancelled',
  })

  const isNewResubscribeFlowEnabled = useAbValues(constants.abTests.resubscribeFlow) === 'b'

  return useMemo<Result>(() => {
    const isFirstTimeResubscribeFlow = (
      isMobile
      && isNewResubscribeFlowEnabled
      && isSubscriptionCancelled
      && firstSubscriptionDate === subscriptionDate // first-time resubscribe only
    )

    const isSecondTimeResubscribeFlow = (
      isSubscriptionCancelled
      && firstSubscriptionDate !== subscriptionDate // SB-1914
    )

    return {
      isFirstTimeResubscribeFlow,
      isSecondTimeResubscribeFlow,
    }
  }, [ isMobile, isNewResubscribeFlowEnabled, firstSubscriptionDate, subscriptionDate, isSubscriptionCancelled ])
}


export default useResubscribeFlows
